import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSubscriptionPermissionsContext } from 'src/mindtime/contexts/SubscriptionPermissionsContext';
import { useEdrModuleAccess } from 'src/mindtime/hooks/useEdrModuleAccess';
import EdrPreviewDataBanner from './EdrPreviewDataBanner';

export const EdrPreviewBannerSlot: FC = () => {
  const { t } = useTranslation('securityEdr');
  const { isPreviewMode, resolved } = useEdrModuleAccess();
  const { hasActiveSubscription, subscriptionKeys } =
    useSubscriptionPermissionsContext();

  if (!resolved) return null;

  const hasEmptySubscriptionEntitlements =
    hasActiveSubscription && subscriptionKeys.size === 0;

  if (hasEmptySubscriptionEntitlements) {
    return (
      <Box px={3} pt={3} pb={0}>
        <Alert severity="info" variant="outlined">
          {t('noEntitlementsBanner.message')}
        </Alert>
      </Box>
    );
  }

  if (!isPreviewMode) return null;

  return (
    <Box px={3} pt={3} pb={0}>
      <EdrPreviewDataBanner />
    </Box>
  );
};
